import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'

export class TmAuthEmailVerificationResendError extends TmAuthError {
  public get availableToResendAt(): string {
    return this.data.availableToResendAt
  }
}
